'use client';

import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

import { Button } from '@/components';

/**
 * @file error.jsx
 * @description Error page to go back to the redirect the page after a timer
 * @version 0.0.2
 * Created at: 17/09/2025
 * Updated at: 17/09/2025
 */
export const GoBackError = ({
  error,
  title = 'Redirecting back in',
  initialTimer = 4,
  url = '#',
}) => {
  //-------------- State & Variables --------------//

  const router = useRouter();
  const [timer, setTimer] = useState(initialTimer);

  //-------------- Use Effects --------------//
  useEffect(() => {
    if (timer <= 0) {
      router.replace(url);
      return;
    }

    const interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timer, router, url]);

  //-------------- Other Methods --------------//

  return (
    <section className="flex h-full items-center justify-center p-4">
      <div className="space-y-4 text-center">
        <h2 className="text-lg font-semibold">{error?.message || 'Something went wrong!'}</h2>
        <Button onClick={() => router.replace(url)}>
          {title} {timer}...
        </Button>
      </div>
    </section>
  );
};
